export function isAdmin(user: any): boolean {
    return user?.userRole === 'admin';
}

export function hasRole(user: any, role: string): boolean {
    return user?.userRole === role;
}

export function hasAnyRole(user: any, roles: string[]): boolean {
    return roles.includes(user?.userRole);
}

export function isStaff(user: any): boolean {
    return user?.userRole!=='customer';
}
export function isScientist(user: any): boolean {
    return user?.userRole==='scientist';
}
